<template>
    <div>
        <slot />
        <div class="margin-bottom-normal">
            <g-typography tag="p" font-weight="semibold">Channels</g-typography>
            <g-typography class="g-mt-3 g-mb-3" tag="p" color="grey-6">
                Choose how you would like to be notified.
            </g-typography>

            <g-checkbox-group v-model="settings.notification_channels">
                <g-checkbox value="mail" size="large" class="g-pr-2" /> <g-typography>Email</g-typography>
            </g-checkbox-group>
        </div>

        <div class="margin-bottom-large">
            <g-typography tag="p" font-weight="semibold">Settings</g-typography>
            <g-typography class="g-mt-3 g-mb-3" tag="p" color="grey-6">Choose what we notify you about.</g-typography>

            <div v-if="featureFlags['creator-reminders']" class="margin-bottom-small">
                <g-checkbox v-model="reconnectNetwork" size="large" class="g-pr-2" />
                <g-typography>Network Connections</g-typography>
            </div>

            <div v-if="featureFlags['creator-content-metric-alerts']" class="margin-bottom-small">
                <g-checkbox v-model="contentMetrics" size="large" class="g-pr-2" />
                <g-typography>Content</g-typography>
            </div>
        </div>

        <div class="margin-bottom-large">
            <g-button :disabled="contactStore.loading" shape="round" theme="live" @click="updateSettings">
                <g-typography font-weight="semibold">Update</g-typography>
            </g-button>
        </div>
    </div>
</template>

<script>
    import {
        CREATOR_REMINDERS_TYPE_RECONNECT_NETWORK,
        CREATOR_NOTIFICATIONS_TYPE_CONTENT_METRICS
    } from '../../../../../app-v2/constants/notifications';
    import { useContactStore, useFeatureFlagsStore } from '../../../../../stores';
    import { message } from '@grininc/grin-ui';
    import { ref, reactive, computed } from 'vue-demi';

    export default {
        name: 'NotificationSettings',

        setup() {
            const contactStore = useContactStore();
            const featureFlags = useFeatureFlagsStore().data;
            const settings = reactive({ notification_channels: contactStore.data.notification_channels || ['mail'] });
            const reconnectNetwork = ref(true);
            const contentMetrics = ref(true);

            if (contactStore.data?.opt_out_notifications?.includes(CREATOR_REMINDERS_TYPE_RECONNECT_NETWORK)) {
                reconnectNetwork.value = false;
            }

            if (contactStore.data?.opt_out_notifications?.includes(CREATOR_NOTIFICATIONS_TYPE_CONTENT_METRICS)) {
                contentMetrics.value = false;
            }

            const getPayload = computed(() => {
                const optOutNotifications = [];

                if (!reconnectNetwork.value) {
                    optOutNotifications.push(CREATOR_REMINDERS_TYPE_RECONNECT_NETWORK);
                }

                if (!contentMetrics.value) {
                    optOutNotifications.push(CREATOR_NOTIFICATIONS_TYPE_CONTENT_METRICS);
                }

                return {
                    notification_channels: settings.notification_channels,
                    opt_out_notifications: optOutNotifications
                };
            });

            const updateSettings = async () => {
                await contactStore.updateNotificationSettings(getPayload.value);
                if (!contactStore.error) {
                    message.success('Your profile has been updated.');
                } else {
                    message.error(contactStore.error);
                }
            };

            return {
                contactStore,
                featureFlags,
                settings,
                reconnectNetwork,
                contentMetrics,
                updateSettings
            };
        }
    };
</script>

<style lang="scss" scoped>
    .margin-bottom-small {
        margin-bottom: $g-spacing-3;
    }

    .margin-bottom-normal {
        margin-bottom: $g-spacing-5;
    }

    .margin-bottom-large {
        margin-bottom: $g-spacing-6;
    }
</style>
